import { render, staticRenderFns } from "./productsModal.vue?vue&type=template&id=159be8ec"
import script from "./productsModal.vue?vue&type=script&lang=js"
export * from "./productsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports